var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0277FF",
    d: "M17.143 1.714a3.429 3.429 0 1 1-2.378 5.899L9.277 10.99a3.43 3.43 0 0 1 0 2.02l5.487 3.377a3.429 3.429 0 1 1-.899 1.46L8.378 14.47a3.429 3.429 0 1 1 0-4.94l5.487-3.377a3.429 3.429 0 0 1 3.277-4.439m0 15.428a1.714 1.714 0 1 0 0 3.43 1.714 1.714 0 0 0 0-3.43M6 10.285a1.714 1.714 0 1 0 0 3.429 1.714 1.714 0 0 0 0-3.429m11.143-6.857a1.714 1.714 0 1 0 0 3.429 1.714 1.714 0 0 0 0-3.429"
  })));
};
export default SvgShare;